// extracted by mini-css-extract-plugin
export default {"discount":"styles_discount__TG+ig"};